import * as React from "react";
import netSvg from "@/assets/netdetect.svg";
import { Button } from "antd";
import styled from "styled-components";

import { SVR_URL, SVR_DOMAIN, BAIDU, GOOG } from "@/config/const";

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  .img {
    width: 200px;
    height: 200px;
    margin-top: 80px;
  }
  .title {
    margin-top: 15px;
    font-size: 18px;
    font-weight: 400;
  }
  .atitle {
    margin-bottom: 15px;
    margin-top: 15px;
    font-size: 13px;
    font-weight: 400;
  }
`;

const NormalSetting: React.FunctionComponent = () => {
  const [testing, setTesting] = React.useState(false);
  const [netStatus, setNetStatus] = React.useState("");
  const [serverStatus, setServerStatus] = React.useState("");
  const [domainStatus, setDomainStatus] = React.useState("");

  const iframeTest = async (url: string, cb: (str: string) => void) => {
    const img: HTMLImageElement = document.createElement("img");
    img.className = "zero";
    const before = +new Date();
    const atimer = setTimeout(() => {
      img.onload = () => {};
      img.onerror = () => {};
      cb("Хэвийн бус");
    }, 10000);
    img.onload = () => {
      const after = +new Date();
      const time = after - before;
      if (time < 500) {
        cb("Сайн");
      } else if (time < 1000) {
        cb("Муу");
      } else {
        cb("Маш муу");
      }
      document.body.removeChild(img);
      clearTimeout(atimer);
    };
    img.onerror = () => {
      cb("Хэвийн бус");
      document.body.removeChild(img);
      clearTimeout(atimer);
    };
    document.body.appendChild(img);
    img.src = url;
  };

  const networkTest = () => {
    setTesting(true);
    iframeTest(BAIDU, (v) => {
      setNetStatus(v);
    });
    iframeTest(SVR_URL, (v) => {
      setServerStatus(v);
    });
    iframeTest(SVR_DOMAIN, (v) => {
      setDomainStatus(v);
    });
  };

  return (
    <Container>
      <img src={netSvg} alt="" className="img" />
      <div className="title">Сүлжээний чанар</div>
      {!testing && (
        <>
          <div className="atitle">Тест эхлүүлэх товчийг дарна уу</div>
          <Button onClick={networkTest}>Тест эхлүүлэх</Button>
        </>
      )}
      {testing && (
        <>
          <div>Интернетийн холболт: {netStatus || "Шалгаж байна..."}</div>
          <div>Серверийн төлөв: {serverStatus || "Шалгаж байна..."}</div>
          <div>DNS: {domainStatus || "Шалгаж байна..."}</div>
        </>
      )}
    </Container>
  );
};

export default NormalSetting;

/**
 * 1, 网络链接， 测试 baidu.com
 * 2, 服务器链接情况，svr_url
 * 3, 域名解析： svr_domain
 * 4, svr_domain， 100毫秒 良好， 300 内，较差， 300外， 极差， 出错，不正常
 *
 */
